import { queryKeys } from "../queryKeys";
import {
  type GetListAcatsTransfersForAccountResponse,
  getListAcatsTransfersForAccount,
} from "../rest/acats";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAcatsTransfers = ({
  accountId,
  pageToken,
  options,
}: {
  accountId: string;
  pageToken?: string;
  options?: QueryOptions<GetListAcatsTransfersForAccountResponse>;
}) => {
  const res = useRequest(
    queryKeys.acats.transfers.page(accountId, pageToken),
    () => getListAcatsTransfersForAccount(accountId, pageToken),
    {
      ...options,
      enabled: !!accountId && (options?.enabled ?? true),
    },
  );

  return res;
};
